"use strict";

var _slicedToArray = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _regeneratorRuntime = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");
var _asyncToGenerator = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _objectSpread = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTurnstile = void 0;
var react_1 = __importStar(require("react"));
var globalNamespace = typeof globalThis !== "undefined" ? globalThis : window;
var turnstileState = typeof globalNamespace.turnstile !== "undefined" ? "ready" : "unloaded";
var ensureTurnstile;
// Functions responsible for loading the turnstile api, while also making sure
// to only load it once
var turnstileLoad;
var turnstileLoadPromise = new Promise(function (resolve, reject) {
  turnstileLoad = {
    resolve: resolve,
    reject: reject
  };
  if (turnstileState === "ready") resolve(undefined);
});
{
  var TURNSTILE_LOAD_FUNCTION = "cf__reactTurnstileOnLoad";
  var TURNSTILE_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js";
  ensureTurnstile = function ensureTurnstile() {
    if (turnstileState === "unloaded") {
      turnstileState = "loading";
      globalNamespace[TURNSTILE_LOAD_FUNCTION] = function () {
        turnstileLoad.resolve();
        turnstileState = "ready";
        delete globalNamespace[TURNSTILE_LOAD_FUNCTION];
      };
      var url = "".concat(TURNSTILE_SRC, "?onload=").concat(TURNSTILE_LOAD_FUNCTION, "&render=explicit");
      var script = document.createElement("script");
      script.src = url;
      script.async = true;
      script.addEventListener("error", function () {
        turnstileLoad.reject("Failed to load Turnstile.");
        delete globalNamespace[TURNSTILE_LOAD_FUNCTION];
      });
      document.head.appendChild(script);
    }
    return turnstileLoadPromise;
  };
}
function Turnstile(_ref) {
  var id = _ref.id,
    className = _ref.className,
    customStyle = _ref.style,
    sitekey = _ref.sitekey,
    action = _ref.action,
    cData = _ref.cData,
    theme = _ref.theme,
    language = _ref.language,
    tabIndex = _ref.tabIndex,
    responseField = _ref.responseField,
    responseFieldName = _ref.responseFieldName,
    size = _ref.size,
    fixedSize = _ref.fixedSize,
    retry = _ref.retry,
    retryInterval = _ref.retryInterval,
    refreshExpired = _ref.refreshExpired,
    appearance = _ref.appearance,
    execution = _ref.execution,
    userRef = _ref.userRef,
    onVerify = _ref.onVerify,
    onSuccess = _ref.onSuccess,
    onLoad = _ref.onLoad,
    onError = _ref.onError,
    onExpire = _ref.onExpire,
    onTimeout = _ref.onTimeout,
    onAfterInteractive = _ref.onAfterInteractive,
    onBeforeInteractive = _ref.onBeforeInteractive,
    onUnsupported = _ref.onUnsupported;
  var ownRef = (0, react_1.useRef)(null);
  var inplaceState = (0, react_1.useState)({
    onVerify: onVerify,
    onSuccess: onSuccess,
    onLoad: onLoad,
    onError: onError,
    onExpire: onExpire,
    onTimeout: onTimeout,
    onAfterInteractive: onAfterInteractive,
    onBeforeInteractive: onBeforeInteractive,
    onUnsupported: onUnsupported
  })[0];
  var ref = userRef !== null && userRef !== void 0 ? userRef : ownRef;
  var style = fixedSize ? _objectSpread({
    width: size === "compact" ? "130px" : size === "flexible" ? "100%" : "300px",
    height: size === "compact" ? "120px" : "65px"
  }, customStyle) : customStyle;
  (0, react_1.useEffect)(function () {
    if (!ref.current) return;
    var cancelled = false;
    var widgetId = "";
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _a, _b, boundTurnstileObject, turnstileOptions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(turnstileState !== "ready")) {
                _context.next = 10;
                break;
              }
              _context.prev = 1;
              _context.next = 4;
              return ensureTurnstile();
            case 4:
              _context.next = 10;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              (_a = inplaceState.onError) === null || _a === void 0 ? void 0 : _a.call(inplaceState, _context.t0);
              return _context.abrupt("return");
            case 10:
              if (!(cancelled || !ref.current)) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return");
            case 12:
              turnstileOptions = {
                sitekey: sitekey,
                action: action,
                cData: cData,
                theme: theme,
                language: language,
                tabindex: tabIndex,
                "response-field": responseField,
                "response-field-name": responseFieldName,
                size: size,
                retry: retry,
                "retry-interval": retryInterval,
                "refresh-expired": refreshExpired,
                appearance: appearance,
                execution: execution,
                callback: function callback(token, preClearanceObtained) {
                  var _a, _b;
                  (_a = inplaceState.onVerify) === null || _a === void 0 ? void 0 : _a.call(inplaceState, token, boundTurnstileObject);
                  (_b = inplaceState.onSuccess) === null || _b === void 0 ? void 0 : _b.call(inplaceState, token, preClearanceObtained, boundTurnstileObject);
                },
                "error-callback": function errorCallback(error) {
                  var _a;
                  return (_a = inplaceState.onError) === null || _a === void 0 ? void 0 : _a.call(inplaceState, error, boundTurnstileObject);
                },
                "expired-callback": function expiredCallback(token) {
                  var _a;
                  return (_a = inplaceState.onExpire) === null || _a === void 0 ? void 0 : _a.call(inplaceState, token, boundTurnstileObject);
                },
                "timeout-callback": function timeoutCallback() {
                  var _a;
                  return (_a = inplaceState.onTimeout) === null || _a === void 0 ? void 0 : _a.call(inplaceState, boundTurnstileObject);
                },
                "after-interactive-callback": function afterInteractiveCallback() {
                  var _a;
                  return (_a = inplaceState.onAfterInteractive) === null || _a === void 0 ? void 0 : _a.call(inplaceState, boundTurnstileObject);
                },
                "before-interactive-callback": function beforeInteractiveCallback() {
                  var _a;
                  return (_a = inplaceState.onBeforeInteractive) === null || _a === void 0 ? void 0 : _a.call(inplaceState, boundTurnstileObject);
                },
                "unsupported-callback": function unsupportedCallback() {
                  var _a;
                  return (_a = inplaceState.onUnsupported) === null || _a === void 0 ? void 0 : _a.call(inplaceState, boundTurnstileObject);
                }
              };
              widgetId = window.turnstile.render(ref.current, turnstileOptions);
              boundTurnstileObject = createBoundTurnstileObject(widgetId);
              (_b = inplaceState.onLoad) === null || _b === void 0 ? void 0 : _b.call(inplaceState, widgetId, boundTurnstileObject);
            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }))();
    return function () {
      cancelled = true;
      if (widgetId) window.turnstile.remove(widgetId);
    };
  }, [sitekey, action, cData, theme, language, tabIndex, responseField, responseFieldName, size, retry, retryInterval, refreshExpired, appearance, execution]);
  (0, react_1.useEffect)(function () {
    inplaceState.onVerify = onVerify;
    inplaceState.onSuccess = onSuccess;
    inplaceState.onLoad = onLoad;
    inplaceState.onError = onError;
    inplaceState.onExpire = onExpire;
    inplaceState.onTimeout = onTimeout;
    inplaceState.onAfterInteractive = onAfterInteractive;
    inplaceState.onBeforeInteractive = onBeforeInteractive;
    inplaceState.onUnsupported = onUnsupported;
  }, [onVerify, onSuccess, onLoad, onError, onExpire, onTimeout, onAfterInteractive, onBeforeInteractive, onUnsupported]);
  return react_1.default.createElement("div", {
    ref: ref,
    id: id,
    className: className,
    style: style
  });
}
exports.default = Turnstile;
function createBoundTurnstileObject(widgetId) {
  return {
    execute: function execute(options) {
      return window.turnstile.execute(widgetId, options);
    },
    reset: function reset() {
      return window.turnstile.reset(widgetId);
    },
    getResponse: function getResponse() {
      return window.turnstile.getResponse(widgetId);
    },
    isExpired: function isExpired() {
      return window.turnstile.isExpired(widgetId);
    }
  };
}
function useTurnstile() {
  // we are using state here to trigger a component re-render once turnstile
  // loads, so the component using this hook gets the object once its loaded
  var _ref3 = (0, react_1.useState)(turnstileState),
    _ref4 = _slicedToArray(_ref3, 2),
    _ = _ref4[0],
    setState = _ref4[1];
  (0, react_1.useEffect)(function () {
    if (turnstileState === "ready") return;
    turnstileLoadPromise.then(function () {
      return setState(turnstileState);
    });
  }, []);
  return globalNamespace.turnstile;
}
exports.useTurnstile = useTurnstile;